import React, { Fragment } from "react";
import { Button } from "../../revvComponents";

export default function RecurringInfoBand(props) {
  return (
    <Fragment>
      <div className="billingbandinfo-wrapper">
        <span>
          Your payment was unsuccessful. Please update the card information to
          avoid service interruption.
        </span>
        <span
          onKeyPress={() => null}
          role="button"
          tabIndex="0"
          onClick={() => {}}
          className="billingbandinfo-updgrade-link"
        />
        {/* </span> */}
        <Button
          data-test="submit-anyway-button"
          className="revv-btn-primary billing-info-button"
          onClick={() => props.updateBilling()}
          onKeyPress={() => {}}>
          Update card
        </Button>
      </div>
    </Fragment>
  );
}
